// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"page_mainDiv__V8Rl1","labelsDiv":"page_labelsDiv__adg3r","mainBox":"page_mainBox__LQsSj","insideBox":"page_insideBox__r3FYV"};